<template>

    <section class="impact">

        <div class="container">

            <h2 class="impact__title">
                {{ 'home_impact' | staticTitle }}
            </h2>

            <div class="impact__line"></div>

            <div class="impact__grid">

                <article
                    v-for="(item, index) in items"
                    :key="index"
                    class="impact__card"
                >

                    <i :class="item.icon"></i>

                    <h3>
                        {{ item.hash | staticTitle }}
                    </h3>

                    <p>
                        {{ item.hash | staticContent }}
                    </p>

                </article>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeImpact',

    data() {
        return {
            items: [
                {
                    hash: 'impact_1',
                    icon: 'fa-regular fa-heart'
                },
                {
                    hash: 'impact_2',
                    icon: 'fa-solid fa-users'
                },
                {
                    hash: 'impact_3',
                    icon: 'fa-regular fa-handshake'
                },
                {
                    hash: 'impact_4',
                    icon: 'fa-solid fa-bullhorn'
                },
                {
                    hash: 'impact_5',
                    icon: 'fa-solid fa-book-open'
                },
                {
                    hash: 'impact_6',
                    icon: 'fa-solid fa-seedling'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.impact {
    background: var(--background);

    padding: 70px 20px;

    text-align: center;

    .container {
        width: 100%;
        max-width: 500px;

        margin: 0 auto;
    }

    &__title {
        font-family: 'Cormorant Garamond', serif;

        font-size: 2.1rem;
        font-weight: 700;

        line-height: 1.2;

        color: var(--text);
    }

    &__line {
        width: 60px;
        height: 3px;

        margin: 18px auto 50px;

        background: var(--primary);
    }

    &__grid {
        display: grid;

        gap: 45px;
    }

    &__card {
        display: flex;
        flex-direction: column;
        align-items: center;

        text-align: center;

        i {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 72px;
            height: 72px;

            margin: 0 auto 22px;

            font-size: 3.1rem;

            color: var(--primary);

            line-height: 1;
        }

        h3 {
            margin-bottom: 12px;

            font-family: 'Poppins', sans-serif;

            font-size: .9rem;
            font-weight: 700;

            color: var(--text);
        }

        p {
            max-width: 260px;

            font-family: 'Poppins', sans-serif;

            font-size: .9rem;

            line-height: 1.8;

            color: #666;
        }
    }
}

@media (min-width: 768px) {
    .impact {
        padding: 90px 20px;

        .container {
            max-width: 1200px;
        }

        &__title {
            font-size: 3rem;
        }

        &__grid {
            grid-template-columns: repeat(3, 1fr);

            gap: 50px 30px;
        }
    }
}

@media (min-width: 1100px) {
    .impact {

        &__grid {
            grid-template-columns: repeat(6, 1fr);

            gap: 0;
        }

        &__card {
            position: relative;

            padding: 0 22px;

            display: flex;
            flex-direction: column;
            align-items: center;

            i {
                width: 62px;
                height: 62px;

                margin: 0 auto 22px;

                flex-shrink: 0;

                display: flex;
                align-items: center;
                justify-content: center;

                font-size: 3rem;

                line-height: 1;
            }

            h3 {
                width: 100%;
                min-height: 38px;

                margin: 0 0 12px;

                display: flex;
                align-items: center;
                justify-content: center;

                font-size: .95rem;

                line-height: 1.2;
            }

            p {
                width: 100%;
                max-width: none;

                margin: 0;

                font-size: .88rem;

                line-height: 1.7;
            }

            &:not(:last-child)::after {
                content: '';

                position: absolute;

                top: 10px;
                right: 0;

                width: 1px;
                height: 170px;

                background: #e8e8e8;
            }
        }
    }
}
</style>